import Container from 'semantic-ui-react/dist/commonjs/elements/Container';
import '@purple/semantic-ui-family-connection-theme/components/container.css';

export default Container;
